export default __webpack_public_path__ + "static/media/eletric1.44f92871.jpeg";